/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointRequestHistoryActionsCreator" />
import { ServiceEndpointRequestHistoryActionsHub, IServiceEndpointRequestHistoryState } from "DistributedTaskUI/ServiceEndpoints/Details/Actions/ServiceEndpointRequestHistoryActionsHub";
import { ServiceEndpointsSource } from "DistributedTaskUI/ServiceEndpoints/Details/Source/ServiceEndpointsSource";
import { ServiceEndpointUtils } from "DistributedTaskUI/ServiceEndpoints/Details/Utils/ServiceEndpointUtils";
import { ActionCreatorBase } from "DistributedTask/Flux/Actions";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { ServiceEndpointExecutionRecord } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";

import { IVssPageContext } from "VSS/Platform/Context";

export class ServiceEndpointRequestHistoryActionsCreator extends ActionCreatorBase {
    constructor(context: IVssPageContext) {
        super();
        this._source = ServiceEndpointsSource.getInstance(context);
    }
    
    public initialize(): void {
        this._actions = ActionsHubManager.GetActionsHub<ServiceEndpointRequestHistoryActionsHub>(ServiceEndpointRequestHistoryActionsHub);
    }

    public static getKey(): string {
        return "service-endpoints-history-actions-creator";
    }

    public fetchServiceEndpointRequestHistoryRecords(endpointId: string, top?: number, continuationToken?: number) {
        this._source.getServiceEndpointExecutionRecords(endpointId, top, continuationToken).then((records: ServiceEndpointExecutionRecord[]) => {
            if (!records || records.length < 1) {
                this._actions.updateState.invoke({hasMore: false});
            } else {
                let hasMore = false;
                if (records.length >= ServiceEndpointRequestHistoryActionsCreator.DefaultTopForEndpointExecutionRecords) {
                    hasMore = true;
                }
                const continuationToken = ServiceEndpointUtils.getContinuationToken(records);
                this._actions.updateState.invoke({continuationToken: continuationToken, serviceEndpointRequestHistoryRecords: records, hasMore: hasMore});
            }
        });
    }

    public updateState(state: IServiceEndpointRequestHistoryState) {
        this._actions.updateState.invoke(state);
    }

    public static DefaultTopForEndpointExecutionRecords = 25;
    private _actions: ServiceEndpointRequestHistoryActionsHub;
    private _source: ServiceEndpointsSource;
}
